/**
 * Brand marks — the logos drawn in the scenes, as single paths on a
 * 24 × 24 box.
 *
 * Paths from Simple Icons 16.34 (https://simpleicons.org, CC0). The logos
 * themselves are trademarks of their owners, shown here to name the tools.
 *
 * @module components/brands
 */

import brands from '../../data/brands.json';

/**
 * The marks live in `assets/site/data/brands.json`, which the server reads
 * too (App\Site\Brands): the pills are written by Twig, the scenes are
 * drawn here — one table for both.
 *
 * @type {Record<string, string>}
 */
const PATHS = brands.paths;

/**
 * The path of a mark, to draw it inside a scene.
 *
 * @param {string} name - A key of PATHS.
 * @returns {string}
 */
export function brandPath(name) {
    if (!(name in PATHS)) {
        throw new Error(`Unknown brand: ${name}`);
    }

    return PATHS[name];
}
